module.exports = __webpack_public_path__ + "static/media/bo.ca468417.jpg";